const reactSelectOptionsFromArray = (data, labelKey) => {
  if (!labelKey || !data || (data && Array.isArray(data) && data.length === 0)) {
    return [];
  }

  return data.map((item) => {
    return {
      label: item[labelKey],
      value: item?.id
    };
  })
};

export default reactSelectOptionsFromArray;
